import React from 'react';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { formatarValorBRL } from '@spark/utils/formatters';

export const getCobrancasDepositoColumns = (onCancelarCobranca, cancelandoCobranca) => [
  {
    id: 'numeroPedidoTMS',
    header: 'Numero Pedido Embarcador',
    accessorKey: 'numeroPedidoTMS',
    size: 200,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={22} />
  },
  {
    id: 'cnpjCliente',
    header: 'CNPJ Cliente',
    accessorKey: 'cnpjCliente',
    size: 160,
    enableSorting: false,
    cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={18} />
  },
  {
    id: 'nomeCliente',
    header: 'Nome Cliente',
    accessorKey: 'nomeCliente',
    size: 180,
    enableSorting: false,
    cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={20} />
  },
  {
    id: 'tipoCobranca',
    header: 'Tipo Cobrança',
    accessorKey: 'tipoCobranca',
    size: 140,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue() || '-'}</span>
  },
  {
    id: 'numerosNF',
    header: 'NF(s)',
    accessorKey: 'numerosNF',
    size: 280,
    enableSorting: false,
    cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={36} />
  },
  {
    id: 'valorTotalEmitido',
    header: 'Valor Total Emitido',
    accessorKey: 'valorTotalEmitido',
    size: 150,
    enableSorting: true,
    cell: ({ row }) => <span>{formatarValorBRL(row.original.valorTotalEmitido)}</span>
  },
  {
    id: 'quantidadeTotalCaixas',
    header: 'Qtd. Total Caixas',
    accessorKey: 'quantidadeTotalCaixas',
    size: 130,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue() ?? 0}</span>
  },
  {
    id: 'quantidadeTotalEtiquetas',
    header: 'Qtd. Total Etiquetas',
    accessorKey: 'quantidadeTotalEtiquetas',
    size: 145,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue() ?? 0}</span>
  },
  {
    id: 'quantidadeTotalPaletes',
    header: 'Qtd. Total Paletes',
    accessorKey: 'quantidadeTotalPaletes',
    size: 135,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue() ?? 0}</span>
  },
  {
    id: 'usuarioEmissao',
    header: 'Usuário Emissão',
    accessorKey: 'usuarioEmissao',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={20} />
  },
  {
    id: 'dataEmissao',
    header: 'Data Emissão',
    accessorKey: 'dataEmissao',
    size: 170,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue() || '-'}</span>
  },
  {
    id: 'acoes',
    header: 'Ações',
    accessorKey: 'acoes',
    size: 130,
    enableSorting: false,
    cell: ({ row }) => {
      const protocolo = row.original?.protocoloPedidoTMS;
      const tipoCobranca = row.original?.tipoCobranca;
      const isLoading = cancelandoCobranca?.tipoCobranca === tipoCobranca && cancelandoCobranca?.protocolo === protocolo;

      return (
        <ButtonWithLoading
          loading={isLoading}
          loadingText="Cancelando..."
          variant="outline-danger"
          size="sm"
          onClick={() => onCancelarCobranca(row.original)}
          disabled={!protocolo || !onCancelarCobranca}
        >
          Cancelar
        </ButtonWithLoading>
      );
    }
  }
];
